__turbopack_context__.v({
  "answer": "Faqs-module__GVoAYa__answer",
  "arrow": "Faqs-module__GVoAYa__arrow",
  "container": "Faqs-module__GVoAYa__container",
  "faq": "Faqs-module__GVoAYa__faq",
  "highlight": "Faqs-module__GVoAYa__highlight",
  "list": "Faqs-module__GVoAYa__list",
  "listItem": "Faqs-module__GVoAYa__listItem",
  "main": "Faqs-module__GVoAYa__main",
  "open": "Faqs-module__GVoAYa__open",
  "question": "Faqs-module__GVoAYa__question",
});
